import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  stepperDescr: {
    fontSize: "80%",
  },
}));
